import { render, staticRenderFns } from "./IconBellOutline.vue?vue&type=template&id=232ad36d"
import script from "./IconBellOutline.vue?vue&type=script&lang=js"
export * from "./IconBellOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports